// @flow

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { viewerFragment } from 'common/fragments'

const tweetCampaignQuery = gql`
query TweetCampaign (
  $uid: String!,
) {
  tweetCampaign(uid: $uid) {
    uid
    title
    pageTitle
    pageDescription
    eyeCatchingImage
    eyeCatchingSubtitle
    eyeCatchingTitle
    ogImage
    prizeLeadStatement
    prizeTitle
    prizeContent
    secondePrizeLeadStatement
    secondePrizeTitle
    articleLeadStatement
    roomLeadStatement
    roomListLinkTitle
    roomListLink
    startedAt
    endedAt
    applicationMethodTitle
    applicationMethodContent
    tweetLinkTitle
    tweetLink
    notificationMethodContent
    featureLeadStatement
    breadcrumbs {
      title
      path
    }
    articles {
      results {
        id
        tagTitle
        title
        content
        image
        sortOrder
      }
    }
    rooms {
      results {
        id
        title
        content
        image
        area
        capacity
        roomUrl
        sortOrder
      }
    }
    details {
      results {
        id
        title
        content
        sortOrder
      }
    }
    features {
      results {
        id
        title
        image
        content
        linkTitle
        link
      }
    }
  }
  viewer {
    ${viewerFragment}
  }
}`

export default (component: any) => {
  return graphql(tweetCampaignQuery, {
    options: (props: PropTypes) => ({
      variables: {
        uid: props.match.params.tweetCampaignUid || '',
      },
    }),
  })(component)
}



// WEBPACK FOOTER //
// ./src/containers/pages/TweetCampaignPage/graphql.js